//deps
import React, {
    useState,
    useEffect
} from 'react'

import {
    Navigate,
    useNavigate
} from 'react-router-dom';
import {
    FaChevronLeft, FaUser,
    FaChevronRight
} from "react-icons/fa";
// import FacebookLogin from 'react-facebook-login';
import { useGoogleLogin } from '@react-oauth/google';

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
// import {Row} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// styles
import './style.css';
//components
import Input from "../../components/Inputs/Control";
//api
import { signin, signInGoogle } from "../../api/auth";
//api
import { removeUserSession, setUserSession } from '../../utils/common';

import { useAppStore } from "../../context/state";

const LoginForm = ({gclientId, lang}) => {
    
    let history = useNavigate();
    const isAuth =  useAppStore.getState().isAuth    
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        email: "",
        password: "",
        message: {}
    });

    const [isValid, setValidate] = useState(false)

    const handleOnchange = (event) => {
        const {
            name,
            value
        } = event.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleOnBlur = (event) => {
        const { id } = event.target;
        validateInputField(id);
    };

    const validateInputField = (name) => {
        if (name === "email") {
            setValidate(validEmail());
        } else if (name === "password") {
            setValidate(validPassword());
        }
        return isValid
    };

    const validEmail = () => {
        let value = formData.email;
        if (value === "") {
            setFormData({
                ...formData,
                ...{"message": {"email":{"type":"text-warning", "text":lang.login_emailerror}}}
            });
            return false;
        }
        return true;
    };

    const validPassword = () => {
        let value = formData.password;
        if (value === "") {
            /* eslint-env es6 */
            setFormData({
                ...formData,
                ...{"message": {"password":{"type":"text-warning", "text":lang.login_passerror}}}
            });
            return false;
        }
        return true;
    };

    const loginGoogle = useGoogleLogin({
        clientId:gclientId,
        onSuccess: data => {
            signInGoogle(data).then((response) => {
                const { token, user } = response.data;
                sessionStorage.setItem('token', token);
                sessionStorage.setItem('user', JSON.stringify(user));
            })
        },
        onError: response => {
            toast.success('No puede acceder a su cuenta usando Google.', {
                position: "top-right",
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
            });
            setLoading(false);
            removeUserSession();
        }
    });

    useEffect(() => {

    },[isAuth])

    const handleSubmit = (e) => {
        e.preventDefault();
        if(!isValid) return;
        let customId = true;
        setLoading(true);
        signin(formData)
            .then(function (response) {
                const { user } = response.data;
                if( user ){
                    setLoading(false);
                    setUserSession( user );
                    toast.success(lang['welcome'], {
                        toastId: customId,
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        pauseOnFocusLoss: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        onClose: () => {
                            // if(sessionStorage.getItem('token')) {
                            //     setLoading(false);
                            //     history('/shopping-cart');
                            // }
                            customId = null;
                        }
                    });
                }
            }).catch(function (error) {

                let {message, multiple} = error.response.data
                        ? error.response.data.error
                        : {message:error.code, multiple:false};

                if(multiple){
                    message.map((item)=>
                        toast.error(lang[item.message], {
                            toastId: item.message,
                            position: "top-right",
                            autoClose: 4000,
                            hideProgressBar: false,
                            pauseOnFocusLoss: false,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            progress: undefined
                        })
                    )
                }else{
                    toast.error(lang[message], {
                        toastId: message,
                        position: "top-right",
                        autoClose: 4000,
                        hideProgressBar: false,
                        pauseOnFocusLoss: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined
                    })
                }
                setLoading(false);
                removeUserSession();
            });
    }

    return (
        <div>
            <ToastContainer />
             { isAuth  ?
                (<Navigate replace to="/editorial/user-profile" />) : (
                    <div className="login-wrap">
                    <>
                    <p>{lang.login_networks}</p>
                    <div>
                        <Button variant="primary" size="sm">
                            Facebook
                        </Button>{' '}
                        <Button variant="secondary" size="sm" onClick={() => loginGoogle()}>
                            Google+
                        </Button>
                    </div>
                    <p>{lang.login_forms}</p>
                    <Form onSubmit={handleSubmit}>
                        <Input
                            onChange={handleOnchange}
                            onBlur={handleOnBlur}
                            message={formData.message}
                            value={formData.email}
                            id="email"
                            autoComplete={'on'}
                            type="email"
                            label={lang.login_email}
                            placeholder={lang.login_placeholderemail}
                        />
                        <Input
                            onChange={handleOnchange}
                            onBlur={handleOnBlur}
                            message={formData.message}
                            value={formData.password}
                            id="password"
                            type="password"
                            label={lang.login_pass}
                            placeholder={lang.login_placeholderpass}
                        />
                        <div >
                            <Button variant="outline-secondary" onClick={()=> history(-1)}>
                                <FaChevronLeft/> {' '} {lang.login_btncancel}
                            </Button>{' '}
                            <Button variant="primary" type="submit" disabled={!isValid || loading}>
                                <FaUser /> {' '} {lang.login_btnaccess}
                            </Button>{' '}
                            <Link to="/editorial/user-forgot-password"> {lang.login_forgot}</Link>
                            <Link to="/editorial/user-register" className="btn float-end btn-primary" >
                                {lang.login_btnregister} {' '} <FaChevronRight/>
                            </Link>
                        </div>
                    </Form>
                </>
            </div>
        )}
        </div>
    );
};

export default LoginForm;

